import { Layout, Model } from 'flexlayout-react';
import { DocumentData } from '../../context/DocumentDataProvider';
import { findReactFlowTabset } from './FindReactFlowTabset';

// Función para agregar un nuevo heatmap
export const handleAddHeatMapVideo = (
    setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>,
    setPlots: React.Dispatch<React.SetStateAction<Map<string, any>>>,
    layoutModel: Model,
    setLayoutModel: React.Dispatch<React.SetStateAction<Model>>,
    uniqueId: string,
    heatMapName: string,
) => {
    let newHeatMapName = '';
    setPlots(prev => {
        const updated = new Map(prev);
        const newIndex = (prev?.size || 0) + 1;
        newHeatMapName = heatMapName || `Heatmap ${newIndex}`;

        // Datos de ejemplo: 5 frames de heatmap
        const frames = [0, 1, 2, 3, 4].map(t => ({
            z: [
                [1 + t, 20 + t, 30 + t, 40 + t],
                [20 + t, 1 + t, 60 + t, 70 + t],
                [30 + t, 60 + t, 1 + t, 80 + t],
                [40 + t, 70 + t, 80 + t, 1 + t*10]
            ],
            x: [1, 2, 3, 4],
            y: [1, 2, 3, 4],
            type: 'heatmap',
            colorscale: 'Viridis',
            name: newHeatMapName,
            t: t, // tiempo
        }));

        // El estado inicial es el primer frame
        const newHeatMap = {
            id: uniqueId,
            frames: frames, // todos los frames
            currentFrame: 0, // índice del frame actual
            data: [frames[0]], // solo el frame actual
            layout: {
                title: { text: `Heatmap Video Example (t = 0)` },
                xaxis: { title: { text: 'X axis' } },
                yaxis: { title: { text: 'Y axis' } },
            },
        };
        updated.set(uniqueId, newHeatMap);
        return updated;
    });

    setLayoutModel(prevModel => {
        const json = prevModel.toJson();
        const tabset = findReactFlowTabset(json.layout);
        if (tabset) {
            const newTab = {
                id: uniqueId,
                type: 'tab',
                name: newHeatMapName,
                component: 'HeatMapVideoTab',
                config: {},
                enableClose: false,
                enableDrag: true,
                enableRename: true,
                children: [],
                icon: 'camera-icon.svg',
            };
            tabset.children.push(newTab);
        } else {
            console.warn('No tabset found in layout JSON to add the heatmap tab.');
        }
        return Model.fromJson(json);
    });
};